import { createApp, defineAsyncComponent } from 'vue';
import './typedef';

/**
 * App - Class representing vue instance
 */
export default class App {
  constructor() {
    this.app = null;
    this.appElement = document.getElementById('app');
  }

  /**
   * Init vue application
   */
  init() {
    if (this.appElement) {
      this.app = createApp({});

      const loader = this.appElement.querySelector('.js-list-on-load');
      if (loader) {
        const { clientHeight } = loader;
        this.appElement.style.minHeight = `${clientHeight}px`;
      }

      this.app.config.globalProperties.essity = window.essity;
      this.app.config.globalProperties.window = window;

      // Defining components
      this.app.component('essity-calendar', defineAsyncComponent(() => import('./calendar.vue')));
      this.app.component('essity-download-media', defineAsyncComponent(() => import('./download-media.vue')));
      this.app.component('essity-financial-reports', defineAsyncComponent(() => import('./financial-reports.vue')));
      this.app.component('essity-general-meetings', defineAsyncComponent(() => import('./general-meetings.vue')));
      this.app.component('essity-job-opportunities', defineAsyncComponent(() => import('./job-opportunities.vue')));
      this.app.component('essity-news-features', defineAsyncComponent(() => import('./news-features.vue')));
      this.app.component('essity-press-center', defineAsyncComponent(() => import('./press-center.vue')));
      this.app.component('essity-press-releases', defineAsyncComponent(() => import('./press-releases.vue')));
      this.app.component('essity-press-releases-2', defineAsyncComponent(() => import('./press-releases-2.vue')));
      this.app.component('essity-search-advanced', defineAsyncComponent(() => import('./search-advanced.vue')));
      this.app.component('essity-work-day', defineAsyncComponent(() => import('./work-day.vue')));

      // Partials
      this.app.component('file-list', defineAsyncComponent(() => import('./partials/file-list.vue')));
      this.app.component('modal', defineAsyncComponent(() => import('./partials/modal.vue')));
      this.app.component('no-results', defineAsyncComponent(() => import('./partials/no-results.vue')));
      this.app.component('pagination', defineAsyncComponent(() => import('./partials/pagination.vue')));
      this.app.component('result-list', defineAsyncComponent(() => import('./partials/result-list.vue')));
      this.app.component('tab', defineAsyncComponent(() => import('./partials/tab.vue')));
      this.app.component('Select2', defineAsyncComponent(() => import('./partials/select2.vue')));
      this.app.component('filter-buttons', defineAsyncComponent(() => import('./partials/filter-buttons.vue')));
      this.app.component('filter-buttons-category', defineAsyncComponent(() => import('./partials/filter-buttons-category.vue')));
      this.app.component('toggle-button', defineAsyncComponent(() => import('./partials/toggle-button.vue')));

      this.app.mount('#app');
    }
  }
}
